// "Your AI Started Sending UI, Not Text (How I Would Build A2UI)" — forward-looking short.
// Cold Compute / Neon kit. ~150s @ 30fps.
//
// HONESTY: A2UI is an EXTERNAL Google protocol. As of 2026-06-05 EAKC ships the
// TIER-2 FOUNDATION only — a safe component catalog + fail-closed validator +
// renderer + an `interactive` artifact type (src/lib/agents/ui/, 17 tests). The
// LAST MILE (agent emitting A2UI + chat rendering it end-to-end) is still roadmap
// (C4). So the forward-looking scenes keep the roadmap tag; the honesty scene now
// reads "foundation shipped · last mile queued". Grounded in
// docs/2026-05-07-eakc-strategic-synthesis.md §Part 6 +
// docs/visual-companion/2026-06-05-generative-ui-curve.html (Card 5 status).
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames; contiguous (next.start = prev.start + prev.duration).
export const SCENE = {
  hook: { start: 0, duration: 165 }, //        0:00–0:05.5  the AI sends UI, not text
  problem: { start: 165, duration: 480 }, //   0:05.5–0:21  markdown wall: no buttons, no forms
  intuition: { start: 645, duration: 390 }, // 0:21–0:34    agent "speaks UI" from a safe catalog
  whatis: { start: 1035, duration: 540 }, //   0:34–0:52    what A2UI actually is (Google, JSONL, safe)
  flow: { start: 1575, duration: 510 }, //     0:52–1:09    stream → render → events loop
  hookin: { start: 2085, duration: 600 }, //   1:09–1:29    the 2 EAKC seams I'd hook into
  code: { start: 2685, duration: 720 }, //     1:29–1:53    the A2UI payload (sketch, not shipped)
  honesty: { start: 3405, duration: 450 }, //  1:53–2:08    status: planned · v2 · not yet shipped
  outro: { start: 3855, duration: 345 }, //    2:08–2:19.5
} as const;

export const TOTAL_DURATION = 4200; // 140s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
